import {Locale, useHostName, usePublicProtocol} from '@aboutyou/config';
import {Head} from '@aboutyou/head-elements';
import {useLocale} from '@aboutyou/i18n';
import Page from '@aboutyou/legacy-desktop/src/app/pages/Welcome/WelcomePage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Welcome/redial';
import {
  useGenderedCampaignCard,
  withLaunchTeaserRedirect,
} from '@aboutyou/logic-components';
import React, {StrictMode} from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const LegacyWelcomePage = withLaunchTeaserRedirect(
  withLegacyProviders(PageWithRedial),
);

export const WelcomePage = () => {
  const campaignCard = useGenderedCampaignCard();

  return (
    <>
      <StrictMode>
        <AddBecomMetaTag />
      </StrictMode>
      <LegacyWelcomePage campaignCard={campaignCard} />
    </>
  );
};

/**
 * hardcoded metatag for BE locale only
 */
const AddBecomMetaTag = () => {
  const hostname = useHostName();
  const protocol = usePublicProtocol();
  const canonicalUrl = `${protocol}://${hostname}/`;
  const locale = useLocale();

  return (
    <Head>
      {(locale === Locale.fr_BE || locale === Locale.nl_BE) && (
        <meta name="tp-claim" content="429a9c1167ec2d" />
      )}
      <link data-rh="true" rel="canonical" href={canonicalUrl} />
    </Head>
  );
};
